import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Error, Success } from "../../../commons/Messages/Messages";
import axios from "axios";
import AddEditEmployees from "./AddEditEmployees";
import DeleteModal from "../../../commons/DeleteModal/DeleteModal";
import { SocketContext } from "../../../context/SocketContext";

import DropdownComp from "../../../commons/Dropdowns/DropdownComp";
import GeneralTable from "../../../commons/GeneralTable";
import SearchBarComp from "../../../commons/SearchBar/SearchBar";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import Tagcomp from "../../../commons/TagComp/Tagcomp";
import { isAuthenticated } from "../../../commons/Auth/auth";

import { useTranslation } from "react-i18next";
import PageToolbar from "../../../design-system/PageToolbar";

const Employees = () => {
  const { t } = useTranslation("dashboard");
  const socket = useContext(SocketContext);
  const [layout, setLayout] = useState("list");
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(10);

  const location = useLocation();

  const pageParentName = location.pathname.split("service-provider/")[1];

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "name",
      mobile: "title",
      render: (text, record) => (
        <>
          {record.firstName} {record.lastName}
        </>
      ),
      sorter: (a, b) => a.firstName.localeCompare(b.firstName)
    },
    {
      title: t("Custom ID"),
      dataIndex: "employeeId"
    },
    {
      title: t("Email"),
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email)
    },
    {
      title: t("Mobile"),
      dataIndex: "phone",
      sorter: (a, b) => a.phone.length - b.phone.length
    },
    {
      title: t("Status"),
      dataIndex: "status",
      mobile: "subtitle",
      render: (text, record) => <Tagcomp text={record.status} />
    },
    {
      title: t("Action"),
      key: "action",
      align: "right",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "view",
            link: `/user/user-profile/${obj?._id}`
          },
          {
            key: "edit",
            component: () => <AddEditEmployees data={obj} updateParent={getData} />
          },
          {
            key: "delete",
            component: () => (
              <DeleteModal text="Employee" onClick={() => deleteEmployee(obj?._id)} />
            )
          }
        ];
        return (
          <div>
            <DropdownComp menuItems={menuItems} />
          </div>
        );
      }
    }
  ];

  const deleteEmployee = async id => {
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/employees/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          getData();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  const getData = async () => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/employees/limited`,
        {
          serviceProvider: isAuthenticated()?.serviceProviderId,
          searchText,
          pageSize,
          pageNo: pageNo - 1
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setData(res.data.data);
          setTotalCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  const refreshData = () => {
    getData();
  };

  useEffect(() => {
    if (socket) {
      socket.on("refresh service provider data", msg => {
        if (msg) {
          refreshData();
        }
      });
    }
  }, [socket]);

  useEffect(() => {
    getData();

    return () => {};
  }, [searchText, pageNo]);

  useEffect(() => {
    const savedLayout = localStorage.getItem("layout");
    if (savedLayout) {
      setLayout(savedLayout);
    }
  }, []);

  return (
    <>
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={<AddEditEmployees isCreate={true} updateParent={getData} />}
      />
      <GeneralTable
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={data}
        columns={columns}
        setPageNo={setPageNo}
      />
      {/* :
           <EmployeeGridView data={data} updateParent={getData} deleteEmployee={deleteEmployee} />) */}
      {/* } */}
    </>
  );
};

export default Employees;
